import { stateMappings as STATE } from "./validateFunctions";

export const MESSAGE_TYPE = {
    'ERROR' : 'Error',
    'INFO' : 'Info',
    'WARN' : 'Warn',
    'SUCCESS' : 'Ok'
}

export const MESSAGE_FROM = {
    'SDK' : 'SDK',
    'CW' : 'CW'
}
export const MESSAGE_CODE = {
    LOGIN: {
        10000: { code: 10000, message: 'Invalid action, there is no connection to the server.' },
        10001: { code: 10001, message: 'Ocurrio un error inesperado TypeError: Failed to fetch.' },
        10002: { code: 10002, message: 'An unexpected error occurred. To continue, please refresh your browser.' }
    },
    ACCOUNT_CONFIGURATION: {
        10100: { code: 10100, message: 'Invalid action, only in [ Ready ] state.' }
    },
    CALL_DATA: {
        10300: { code: 10300, message: 'Inbound calls are not allowed to update.' },
        10301: { code: 10301, message: 'Invalid action, only in [ Dialog ] state.' },
        10302: { code: 10302, message: 'The value of campaign ID must be a positive number' },
        10303: { code: 10303, message: 'It is not possible to update both the CallKey and contact data in this campaign.' },
        10304: { code: 10304, message: 'It is not possible to update the CallKey in this campaign.' },
        10305: { code: 10305, message: 'It is not possible to update the contact data in this campaign.' },
    },
    BLIND_TRANSFER: {
        10400: { code: 10400, message: 'Call transfers are disabled in CW. Please enable setting 82 to proceed.' },
        10401: { code: 10401, message: 'Invalid action, only in [ Dialog ] state.' },
        10402: { code: 10402, message: 'Blind transfer successfully completed.' },
        10403: { code: 10403, message: 'Call transfer in progress.' },
    },
    ASSISTED_TRANSFER: {
        10500: { code: 10500, message: 'Call transfers are disabled in CW. Please enable setting 82 to proceed.' },
        10501: { code: 10501, message: 'Assisted transfers are disabled in CW. Please enable setting 76 to proceed.' },
        10502: { code: 10502, message: 'Invalid action, only in [ Dialog ] state.' },
        10503: { code: 10503, message: 'Assisted transfer successfully completed.' },
        10504: { code: 10504, message: 'The specified transfer does not exist. Please verify and try again.' },
        10505: { code: 10505, message: 'Connected to the assisting agent successfully.' },
        10506: { code: 10506, message: 'Conference creation requires you to be on the main call. Please ensure you are the primary agent.' },
        10507: { code: 10507, message: 'To transfer the call, you must be on the main call.' },
        10508: { code: 10508, message: 'You must be on the main call to leave the conference. ' },
    },
    CALL_CONTROLS: {
        10700: { code: 10700, message: 'Invalid action, only in [ Ringing | Dialog ] state.' },
        10701: { code: 10701, message: 'Invalid action, only in [ Dialog ] state.' },
        10702: { code: 10702, message: 'The IVR option is not enabled in CW, check setting 117.' },
        10703: { code: 10703, message: "There is no IVR's registered in the database." },
        10704: { code: 10704, message: 'Invalid action, only in [ ' + STATE.ivr.join(' | ') + ' ] state.' },
        10705: { code: 10705, message: 'The campaign does not have permission to hold the call, change column value [holdCall] in DB.' },
        10706: { code: 10706, message: 'The Agent does not have permission to stop/start record the call, check setting 142.' },
        10707: { code: 10707, message: 'The campaign does not have permission to stop/start record the call, check the campaign settings in Admin Kolob.' },
        10708: { code: 10708, message: 'The campaign does not have permission to hang up and leave message, check the campaign settings in Admin Kolob.' },
        10709: { code: 10709, message: 'Processing: Hanging up call and leaving message...'},
        10710: { code: 10710, message: 'The Area does not have permission to display contact information and call controls in transfers.' },
        10711: { code: 10711, message: 'Valid only on transfers and permission for transfers enabled in Area settings.' },
    },
    MANUAL_CALL: {
        10900: { code:10900, message: 'The call might not be completed. The number does not match the standard length.' },
        10901: { code:10901, message: 'You must select a campaign. | The campaign ID cannot be equal to 0.' },
        10902: { code:10902, message: 'Manual call scheduled successfully.' },
        10903: { code:10903, message: 'Scheduled manual call cancelled successfully.' },
        10904: { code:10904, message: 'There are no manual calls scheduled.' },
    },
    UNAVAILABLES: {
        11000: { code: 11000, message: 'Invalid action, only in [ ' + STATE.unavailables.join(' | ') + ' ] state.' },
        11001: { code: 11001, message: 'Not readys assigned to ' },
        11002: { code: 11002, message: 'Error consulting DB, unavailables not created or assigned.' },
        11003: { code: 11003, message: 'Unavailables restricted by Administrator.' },
        11004: { code: 11004, message: 'Cannot set unavailable status, Unavailables restricted by Administrator.' },
        11005: { code: 11005, message: 'Password to change state is required.' },
        11006: { code: 11006, message: 'Admin password is required.' },
        11007: { code: 11007, message: 'Agent password is required.' },
        11008: { code: 11008, message: 'Error notAvailablePassword from server.' },
        11009: { code: 11009, message: 'Error DB, please try again.' },
        11010: { code: 11010, message: 'Invalid action, only in [ Wrapup | NotReady ] state.' }
    },
    DISPOSITIONS: {
        11100: { code: 11100, message: 'Invalid action, only when call is in progress [ Dialog ] or completed [ Wrapup ].' },
        11101: { code: 11101, message: 'Disposition ID or subdisposition ID is not a valid number.' },
        11102: { code: 11102, message: 'Only when the campaign has no dispositions assigned.' },
        11103: { code: 11103, message: 'No call completed.' },
        11104: { code: 11104, message: 'Error consulting DB, no dispositions created or assigned.' },
        11105: { code: 11105, message: 'No dispositions assigned to campaign. If the call is ended, use the method [ exitDispositionMode ].' },
        11106: { code: 11106, message: 'Valid only if there are no dispositions assigned to the campaign, the call is finished and the agent status is [ Wrapup ].' },
        11107: { code: 11107, message: 'Invalid action, only when status is [ Assisted ] .' },
    },
    REPROGRAM_CALL: {
        OUTBOUND: {
            11200: { code: 11200, message: 'The call type is Inbound, please use [ reprogramInbound ] method.' },
            11201: { code: 11201, message: 'Invalid action, no call in progress or completed to reprogram.' },
            11202: { code: 11202, message: 'Telephone number is not valid or is empty.' },
            11203: { code: 11203, message: 'The selected rescheduling date cannot be earlier than the current date.' },
            11204: { code: 11204, message: 'The selected rescheduling date exceeds the limit set in [setting 35].' },
            11205: { code: 11205, message: 'No Dispositions have been assigned to this campaign.' },
            11206: { code: 11206, message: 'The selected Disposition cannot be used to reschedule the call. Please choose another disposition.' },
        },
        INBOUND: {
            11300: { code: 11300, message: 'The call type is Outbound, please use [ reprogramOutbound ] method.' }
        }
    },
    HISTORICAL_EVENTS: {
        11400: { code: 11400, message: 'Invalid action, only in [ ' + STATE.historyUnavailables.join(' | ') + ' ] state.' },
        11401: { code: 11401, message: 'Invalid action, only in [ ' + STATE.historyCalls.join(' | ') + ' ] state.' }
    },
    AUDIO_EVENTS: {
        11500: { code: 11500, message: 'File or server not found, check network settings or server accessibility.' },
        11501: { code: 11501, message: 'Audio played successfully.' },
    },
    CHAT: {
        11600: { code: 11600, message: 'Error chat supervisor list.' },
        11601: { code: 11601, message: 'The message cannot be sent, the selected admin is not logged in.' },
        11602: { code: 11602, message: 'Invalid action, only in [ ' + STATE.chatToAdmin.join(' | ') + ' ] state.' },
        11603: { code: 11603, message: 'Error in chats.' }
    },
    CONNECTION_ALERTS: {
        1: { code: 1, message: 'Server connection lost.' },
        200: { code: 200, message: 'Successful request.' },
        1006: { code: 1006, message: 'Connection lost. Background auto reconnect attempt number: ' },
        8001: { code: 8001, message: 'Telephony server connection lost. Reconnection attempt number: ' },
        8999: { code: 8999, message: 'Telephony server reconnected.' },
    }
};